import { styled } from "styled-components";
import Header from "./Header";
import React, { useEffect, useState } from "react";
import { Navbar } from "./Navbar";
import { theme } from "../styles/theme";

const LayoutContainer= styled.div`
    width: 100vw;
    // height: 100vh;
    display: flex;
    flex-direction: column;
`;  

const PageContent = styled.div`
    width: 100vw;
    height: calc(100svh - 78px);
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: flex-start;
    background: #fff;
    @media (max-width: ${theme.breakpoints.mobile}px) {
      height: calc(100svh - 45px);
  }
`;

const Content = styled.div<{scroll?: boolean}>`
    width: 100vw; //calc(100vw - 88px);
    // height: calc(100vh - 78px);
    height:100%;
    gap: 6px;
    border-top-left-radius: 20px;
    
    // padding-right: 8px;
    // padding-bottom: 8px;
    @media(max-width: ${theme.breakpoints.mobile}px) {
        // height: 100svh;
        overflow: ${({scroll}) => scroll ? 'auto' : 'hidden'};
    }
`;



const Layout = ({children, scroll}: {children: React.ReactNode, scroll?: boolean}) => {
  
  return (
    <LayoutContainer>
      <Header
        onLogoClick={() => {window.location.reload()}}
        onSearchSubmit={() => {}}
        onAskClick={() => {}}
        onAnswerClick={() => {}}
        profileImageSrc="https://randomuser.me/api/portraits/women/44.jpg"
      />
      <PageContent>
        {/* <Navbar /> */}
        <Content scroll={scroll}>{children}</Content>
      </PageContent>
    </LayoutContainer>
  );
};

export default Layout;